import { create } from 'zustand';

const initialState = {
    data: [],
    total: 0,
    totalDay: 0,
    percentTotal: 0,
    title: ''
};

export const useEscaletedLinesTodayStore = create((set) => ({

    ...initialState,

    setEscaletedLinesToday: ({
        data,
        total,
        totalDay,
        percentTotal,
        title
    }) => {
        set({
            data,
            total,
            totalDay,
            percentTotal,
            title
        });
    },

    clearEscaletedLinesToday: () => {
        set(initialState);
    }

}));